"use strict";

var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _clsx = _interopRequireDefault(require("clsx"));
var _WrapperService = require("../../WrapperService");
var _AddToCartDialogView = _interopRequireDefault(require("../AddToCartDialog/AddToCartDialogView"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var AddAllFilesComponent = function AddAllFilesComponent(props) {
  var title = props.title,
    clsName = props.clsName,
    section = props.section,
    addFileQuery = props.addFileQuery,
    responseKeys = props.responseKeys,
    activeFilters = props.activeFilters,
    addFiles = props.addFiles,
    setAlterDisplay = props.setAlterDisplay,
    setOpenSnackbar = props.setOpenSnackbar,
    client = props.client;
  /**
  * conditionally display dialog view
  */
  var _ref = (0, _react.useState)(false),
    _ref2 = _slicedToArray(_ref, 2),
    openAddDialog = _ref2[0],
    setOpen = _ref2[1];
  var toggleOpen = function toggleOpen() {
    return setOpen(!openAddDialog);
  };
  var _ref3 = (0, _react.useState)([]),
    _ref4 = _slicedToArray(_ref3, 2),
    addFilesId = _ref4[0],
    setAddFilesId = _ref4[1];
  /**
  * verify and set file ids
  */
  var addAllFiles = function addAllFiles() {
    var fileIds = (0, _WrapperService.getFilesID)({
      client: client,
      variables: activeFilters,
      query: addFileQuery
    });
    fileIds().then(function (response) {
      var data = response[responseKeys[0]];
      if (data && data.length > 0) {
        var isArray = Array.isArray(data[0][responseKeys[1]]);
        var ids = data.reduce(function (acc, id) {
          if (id && id[responseKeys[1]]) {
            // if object convert to array
            var items = isArray ? id[responseKeys[1]] : [id[responseKeys[1]]];
            acc.push.apply(acc, _toConsumableArray(items));
          }
          return acc;
        }, []);
        if (ids.length > 1000) {
          setAlterDisplay(true);
        } else {
          setOpen(true);
          setAddFilesId(ids);
        }
      } else {
        setOpen(true);
      }
      return [];
    });
  };

  /**
  * use wrapper service to add files to cart
  */
  var addFilesToCart = function addFilesToCart() {
    addFiles(addFilesId);
    toggleOpen();
    setOpenSnackbar(true);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: addAllFiles,
    className: (0, _clsx.default)(clsName, "".concat(clsName, "_").concat(section)),
    disableRipple: true
  }, title), /*#__PURE__*/_react.default.createElement(_AddToCartDialogView.default, {
    open: openAddDialog,
    onYesClick: addFilesToCart,
    onNoClick: toggleOpen
  }));
};
var _default = AddAllFilesComponent;
exports.default = _default;